export default __webpack_public_path__ + "static/media/raiffeisen_background_l2.750a9f1f.jpg";